import React from 'react'

import Menu from '@/components/LandingPage/ContentModel/Layout/Menu'
import ContentModels from '@/components/LandingPage/ContentModels'
import HeaderLogo from '@/components/Layout/Header/Organisms/Header/HeaderLogo'
import { Props } from '@/components/Optimizer/ClientOptimizer'
import { CampaignType } from '@/types/Campaign'
import { ContentModelLayoutType } from '@/types/ContentModel/ContentModelLayout'
import { ProductType } from '@/types/product'

export default function Layout({
  contentModel,
  optimizer = {},
  firstView,
  product,
  campaign,
  afterSubmit,
}: {
  contentModel: ContentModelLayoutType
  optimizer?: Props
  firstView: boolean
  product: ProductType | null
  campaign: CampaignType | null
  afterSubmit: (() => void) | null
}) {
  const contentModels = (
    <>
      {contentModel.contentModels && (
        <>
          {contentModel.headerLogo != false && (
            <div
              style={{
                position: 'fixed',
                top: '3rem',
                left: '8%',
                color: '#fff',
                mixBlendMode: 'exclusion',
                zIndex: 1000,
              }}
            >
              <HeaderLogo fixDesign={false} />
            </div>
          )}
          <ContentModels
            product={product}
            campaign={campaign}
            contentModels={contentModel.contentModels}
            optimizer={optimizer}
            firstView={firstView}
            afterSubmit={afterSubmit}
          />
        </>
      )}
    </>
  )

  const wrapScrollSpy = (contentModels: React.JSX.Element) => {
    if (contentModel.scrollSpies) {
      return (
        <>
          <Menu selectionNames={contentModel.scrollSpies} />
          {contentModels}
        </>
      )
    } else {
      return contentModels
    }
  }

  return <>{wrapScrollSpy(contentModels)}</>
}
